// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditMessage__icon-f03fd9 {
  fill: var(--base-60);
  flex-shrink: 0;
  margin-inline-end: 18px;
}

.EditMessage__title-fec100 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
}

.EditMessage__remove-b119af {
  margin-inline-start: 12px;
}

.EditMessage__miniature-c4809c {
  max-width: var(--max-width-input-top-panel);
  width: 100%;
}

.EditMessage__miniature-title-de960b {
  color: var(--brand-primary-40);
}

.EditMessage__miniature-text-e72255 {
  color: var(--base-80);
}

.EditMessage__miniature-icon-d8cf23 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/EditMessage/EditMessage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".icon {\n  fill: var(--base-60);\n  flex-shrink: 0;\n  margin-inline-end: 18px;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n}\n\n.remove {\n  margin-inline-start: 12px;\n}\n\n.miniature {\n  max-width: var(--max-width-input-top-panel);\n  width: 100%;\n}\n\n.miniature-title {\n  color: var(--brand-primary-40);\n}\n\n.miniature-text {\n  color: var(--base-80);\n}\n\n.miniature-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `EditMessage__icon-f03fd9`,
	"title": `EditMessage__title-fec100`,
	"remove": `EditMessage__remove-b119af`,
	"miniature": `EditMessage__miniature-c4809c`,
	"miniature-title": `EditMessage__miniature-title-de960b`,
	"miniatureTitle": `EditMessage__miniature-title-de960b`,
	"miniature-text": `EditMessage__miniature-text-e72255`,
	"miniatureText": `EditMessage__miniature-text-e72255`,
	"miniature-icon": `EditMessage__miniature-icon-d8cf23`,
	"miniatureIcon": `EditMessage__miniature-icon-d8cf23`
};
module.exports = ___CSS_LOADER_EXPORT___;
